Ext.define('SA.data.ColorScheme', {
    statics: {
        loadAll() {
            return SA.Ajax.request({
                resource: 'legend/colorSchemes',

                success: colors => {
                    this.all = colors;
                }
            });
        }
    }
});